import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgArrowDownCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "inherit",
		d: "M6.25 8.333l3.75 5 3.75-5h-7.5zM18.333 10c0-4.6-3.733-8.333-8.333-8.333A8.336 8.336 0 0 0 1.667 10c0 4.6 3.733 8.333 8.333 8.333S18.333 14.6 18.333 10zm-15 0A6.676 6.676 0 0 1 10 3.333 6.676 6.676 0 0 1 16.667 10 6.676 6.676 0 0 1 10 16.667 6.676 6.676 0 0 1 3.333 10z"
	})
});
export default SvgArrowDownCircle;
